import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from 'avn/interfaces/homepage';
import { ApiService } from 'avn/services/api.service';
import { Constants } from 'avn/services/constants';
import { StoreService } from 'avn/services/store.service';

@Component({
  selector: 'app-category-home',
  templateUrl: './category-home.component.html',
  styleUrls: ['./category-home.component.scss']
})
export class CategoryHomeComponent implements OnInit {
  constructor(
    private store: StoreService,
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService
  ) {}

  relatedCategories = [];
  relatedSubCategories: any[] = [];
  isSymptom = false;

  category = '';
  nodata = false;
  fetchingData = false;
  city = '';
  post_code: '';
  providersList: any[] = [];
  totalProviders = 0;
  pageSize = 9;
  pageNumber = 1;
  totalPages = 0;
  isSuburbPage = false;
  hasCity = false;
  isSubCategoryPage = false;
  mainCategory = '';
  subCatObj = Constants.SUBCATEGORY_LIST;

  groupName = 'Physical';

  ngOnInit(): void {
    this.route.params.subscribe((params_data: any) => {
      const params: any = { ...params_data };
      this.providersList = [];
      this.isSubCategoryPage = this.checkIsSubCategoryPage(params.city);
      if (this.isSubCategoryPage) {
        params.parent_category = params.category_name;
        params.category_name = params.city;
        params.city = params.postcode;
        params.postcode = undefined;
      }
      if (!this.isSubCategoryPage && params.parent_category) {
        this.isSubCategoryPage = true;
        this.mainCategory = params.parent_category;
      }

      this.category = params.category_name;
      this.isSymptom = Constants.HEALTH_CONDITIONS.indexOf(this.category) > -1;

      const cat = this.isSubCategoryPage ? this.mainCategory : this.category;

      this.relatedSubCategories = this.subCatObj[cat] || [];
      this.relatedCategories = Constants.RELATED_CATEGORIES[cat] || [];
      if (this.isSubCategoryPage) {
        const catindex = this.subCatObj[cat].findIndex((x: any) => x.key === this.category);
        const element: any = this.subCatObj[cat].splice(catindex, 1)[0];
        this.relatedSubCategories.unshift(element);
      } else {
        this.relatedSubCategories.unshift({
          key: this.category,
          name: this.category.replace(/-/g, ' '),
          slug: '',
          img: '',
          title: '',
          keywords: '',
          cover: ''
        });
      }

      this.isSuburbPage = !!params.postcode;
      this.hasCity = !!params.city;
      this.city = params.city || 'Sydney';
      this.post_code = params.postcode || '2000';
      this.store.searchBoxParams.next(params);
      this.fetchBizList();
      this.generateGroupName(cat);
    });
  }

  checkIsSubCategoryPage(category: string) {
    this.subCatObj = Constants.SUBCATEGORY_LIST;
    for (const key in this.subCatObj) {
      if (this.subCatObj[key].findIndex((x: any) => x.key === category) > -1) {
        this.mainCategory = key;
        return true;
      }
    }
    return false;
  }

  generateGroupName(cat: string) {
    const groups: any = Constants.CATEGROY_GROUPS;
    for (const key in groups) {
      const index = groups[key].findIndex((x: any) => x.slug === cat);
      if (index > -1) {
        this.groupName = key.toLowerCase();
        break;
      }
    }
  }

  fetchBizList(get_all = false) {
    const params: any = {
      online: false,
      locObj: {
        city: this.city || this.store.meraLocation.city_name,
        post_code: this.post_code || this.store.meraLocation.post_code,
        state: '',
        Loclat: '',
        Loclng: ''
      },
      page_size: this.pageSize,
      distance_range: 25
    };
    if (this.isSymptom) {
      params.symptom = this.category;
      this.fetchingData = true;
      this.api.symptomBusinessesNearMe(params, this.pageNumber).subscribe({
        next: (response) => {
          this.providersList = [...this.providersList, ...response.search_data];
          this.totalProviders = response.total_businesses;
          this.totalPages = response.total_pages;
          if (get_all && this.pageNumber < this.totalPages) {
            this.pageNumber += 1;
            this.fetchBizList(true);
          } else {
            this.fetchingData = false;
          }
          if (this.providersList.length === 0) {
            this.nodata = true;
          }
        },
        error: () => {
          this.nodata = true;
          this.fetchingData = false;
        }
      });
    } else {
      params.service = this.category;
      this.fetchingData = true;
      this.api.wellbeingBusinessesNearMe(params, this.pageNumber).subscribe({
        next: (response) => {
          this.providersList = [...this.providersList, ...response.search_data];
          this.totalProviders = response.total_businesses;
          this.totalPages = response.total_pages;
          if (get_all && this.pageNumber < this.totalPages) {
            this.pageNumber += 1;
            this.fetchBizList(true);
          } else {
            this.fetchingData = false;
          }
        },
        error: (err: any) => {
          this.nodata = true;
          this.fetchingData = false;
          console.info(err);
          if (err.status === 404) {
            this.router.navigate(['/notfound'], {
              skipLocationChange: true
            });
          }
        }
      });
    }
  }

  showAllProviders() {
    const address = `${this.city}, ${this.post_code}`;
    const responseObs = this.api.getGeoCodingByAddress(address);
    responseObs.subscribe({
      next: (response) => {
        const prediction: any = {};
        let state = '';
        let city = '';
        try {
          let postcode = '';

          if (response.geocode_details.results[0].address_components) {
            for (let i = 0; i < response.geocode_details.results[0].address_components.length; i++) {
              const component = response.geocode_details.results[0].address_components[i];
              if (component.types[0] === 'postal_code') {
                postcode = component.long_name;
              } else if (component.types[0] === 'administrative_area_level_1') {
                state = component.long_name;
              } else if (
                component.types[0] === 'locality' ||
                (component.types.length > 2 && component.types[1] === 'locality') ||
                (component.types.length > 3 && component.types[2] === 'locality')
              )
                city = component.long_name;
            }
          }
          if (postcode === '') {
            postcode = this.setMajorCityAndSuburbInfo(city);
          }
          const lng = response.geocode_details.results[0].geometry.location.lng;
          const lat = response.geocode_details.results[0].geometry.location.lat;
          prediction.longitude = lng;
          prediction.latitude = lat;
        } catch (e) {
          console.info(e);
        }
        const loc = new Location();
        loc.lat = prediction.latitude;
        loc.lng = prediction.longitude;
        loc.post_code = prediction.postal_code || this.post_code;
        loc.city_name = city;
        loc.state_name = state;
        localStorage.setItem('meraLocation', JSON.stringify(loc));
        this.store.setmeraLocation(loc);
        const url = `/search/${this.isSymptom ? 'health-condition/' : ''}${this.category}/${this.city
          .toLowerCase()
          .replace(/ /g, '-')}/${this.post_code}/`;
        this.router.navigate([url]);
      }
    });
  }

  setMajorCityAndSuburbInfo(suburb: string) {
    const mc = suburb.toLowerCase();
    if (mc === 'brisbane') {
      return '4000';
    } else if (mc === 'perth') {
      return '6000';
    } else if (mc === 'melbourne') {
      return '3000';
    } else if (mc === 'adelaide') {
      return '5000';
    } else if (mc === 'sydney') {
      return '2000';
    }
    return '';
  }

  fetchRelatedUrl(category: string) {
    return [
      '/category/' +
        category +
        '' +
        (this.hasCity ? '/' + this.city : '') +
        '' +
        (this.isSuburbPage ? '/' + this.post_code : '')
    ];
  }

  getMajorCityForSuburb(slug = false) {
    let majorCity;
    let slugText;
    if (this.post_code.indexOf('2') === 0) {
      majorCity = 'Sydney';
      slugText = 'sydney';
    } else if (this.post_code.indexOf('3') === 0) {
      majorCity = 'Melbourne';
      slugText = 'melbourne';
    } else if (this.post_code.indexOf('4') === 0) {
      majorCity = 'Brisbane';
      majorCity = 'brisbane';
    } else if (this.post_code.indexOf('5') === 0) {
      majorCity = 'Adelaide';
      slugText = 'adelaide';
    } else if (this.post_code.indexOf('6') === 0) {
      majorCity = 'Perth';
      slugText = 'Perth';
    }
    return slug ? slugText : majorCity;
  }
}
